<script>
    export let click_action = null;

    import { icon_folder } from '../inputs/data_paths';
</script>

<span class="visualization__i-icon">
    &nbsp;<img src={`${icon_folder}images/i-icon.svg`} alt="Information icon" on:click={click_action} />
</span>

<style>
.visualization__i-icon {
    display: inline-block;
    white-space: nowrap;
    vertical-align: middle;
}
.visualization__i-icon img {
    cursor: pointer;
}
</style>
